import { Button, Icon, Modal } from '@iwoca/orion';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import {
    CLOSE_ACCOUNT_CREATED_NOTIFICATION,
    RECOGNISE_ACCOUNT_CREATED_NOTIFICATION
} from './AccountCreatedNotification.actions';
import messages from './AccountCreatedNotification.messages';
import styles from './AccountCreatedNotification.module.css';
import { getApplicantEmail } from '../../lendingAPI/lendingAPISelector';

const AccountCreatedNotification = ({
    isOpen,
    closeModal,
    emailAddress,
    recogniseAccountCreated
}) => {
    return (
        <Modal
            className={styles.modalContainer}
            isOpen={isOpen}
            onClose={closeModal}
            data-testid="account-created-notification-modal"
            closeIcon
            size="medium">
            <h2 className={styles.setupAccountMessage}>
                <FormattedMessage {...messages.title} />
            </h2>

            <div
                data-dd-privacy="mask"
                className={classnames('fs-exclude', styles.emailMessage)}>
                <FormattedMessage {...messages.setupAccountMessage} />
                <div className={styles.emailCreated}>{emailAddress}</div>
            </div>

            <hr className={styles.divider} />

            <p className={styles.howToSetPasswordMessage}>
                <div>
                    <Icon icon="checkDefault" className={styles.checkIcon} />
                </div>
                <FormattedMessage {...messages.howToSetPassword} />
            </p>

            <div className={styles.accountCreatedCTAContainer}>
                <Button
                    className={styles.accountCreatedCTA}
                    onClick={recogniseAccountCreated}>
                    <FormattedMessage {...messages.cta} />
                </Button>
            </div>
        </Modal>
    );
};

const mapStateToProps = (state) => {
    return {
        emailAddress: getApplicantEmail(state)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        recogniseAccountCreated: () =>
            dispatch({ type: RECOGNISE_ACCOUNT_CREATED_NOTIFICATION }),
        closeModal: () => dispatch({ type: CLOSE_ACCOUNT_CREATED_NOTIFICATION })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountCreatedNotification);
